import { usePersistentKeyboardVisible } from "#persistent-keyboard-runtime";

/**
 * Mirrors the visibility logic used internally to decide whether the floating
 * dismiss button is rendered. Parents use this to reserve horizontal space for
 * the button so it doesn't overlap the input field.
 */
export function useCollapsiblePersistentKeyboardDismissButtonVisible() {
  return usePersistentKeyboardVisible();
}
